import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { makeStyles } from "tss-react/mui";
import { KeyValueCell } from "../key-value-table/KeyValueCell.js";
import { KeyValueTable } from "../key-value-table/KeyValueTable.js";
import { KeyValueColumn } from "../key-value-table/KeyValueColumn.js";
import "../key-value-table/cells/CurrencyWithDateCell.js";
import { EmptyLabel } from "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
import { formatTimestamp } from "../../utils/date.js";
const localized = defineMessages({
  lastUpdated: {
    id: "layout_lastUpdate",
    defaultMessage: "Last Updated (UTC):"
  }
});
const useClasses = makeStyles()((theme) => ({
  container: {
    marginLeft: "auto"
  },
  column: {
    gridTemplateColumns: "minmax(100px, max-content) auto",
    "& > div": {
      padding: theme.spacing(0, 0, 2.5),
      "& > *": {
        padding: 0
      }
    }
  }
}));
function LastUpdated({ value }) {
  const { formatMessage } = useIntl();
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement("div", { className: classes.container }, /* @__PURE__ */ React.createElement(KeyValueTable, null, /* @__PURE__ */ React.createElement(KeyValueColumn, { className: classes.column }, /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.lastUpdated) }, value ? formatTimestamp(value, "date-time-with-seconds") : /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" })))));
}
export {
  LastUpdated
};
//# sourceMappingURL=LastUpdated.js.map
